define(['jquery', 'jquery.transit', 'modernizr', 'container', 'preloader', 'router', 'scroll'],
    function ($, transit, modernizr, container, preloader, router, scroll) {

        var module = (function () {

            var name = 'module-fan-touchpoint-featured';

            var model = container.getBaseModel(name);
            var view = container.getBaseView(name);
            var pubSub = container.getPublishSubscribe();
            /* model */

            model.publicVars = {};

            model.privateVars = {};

            model.methods = {

            }

            /* view */

            view.publicVars = {};

            view.privateVars = {

            };

            view.startup = function () {
                // scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleFanTouchpointFeaturedHeaderMenuId, 'animate__faster animate__fadeIn', 'fan-touchpoint-featured', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleFanTouchpointFeaturedContentAreaId, 'animate__faster animate__zoomIn', 'fan-touchpoint-featured', {});
            };

            view.bind = function () {

            };

            view.methods = {

            };

            /* custom events */
            //pubSub.subscribe('view/actionShowFormThx', view.methods.actionShowFormThx);
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function (options) {
                    model.init(options);
                    view.init(options);
                    scroll.init();
                }
            };


        })();

        return module;


    });
